<template>
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <div class="common-form">首页</div>
      <!-- <el-form-item label="LOGO">
        <el-button type="primary" plain icon="el-icon-upload" @click="openUpload(2)">上传图片</el-button>
        <div v-if="form.logo != ''" class="img"><img :src="form.logo" height="100" /></div>
      </el-form-item> -->

      <el-form-item label="首页通知">
        <el-input v-model="form.notice.text" class="max-w460" style="width:400px"></el-input>
        <el-input v-model="form.notice.linkUrl" class="max-w460" style="width:400px"></el-input>
        <el-button type="primary" @click="changeLink('notice')">选择链接</el-button>
      </el-form-item>
      

      <el-form-item label="首页轮播图片">
        <el-button type="primary" plain icon="el-icon-plus" @click="addBanner()">添加</el-button>
        <p class="gray9">可以拖动主图改变排序位置，改变后点【保存】才生效</p>
        <div class="draggable-list">
          <draggable class="" v-model="form.banner">
            <transition-group>
              <div v-for="(v, i) in form.banner" :key="i+1">
                <div class="d-s-c d-r p-10-0" >
                  <div>
                    <div v-if="v.imgUrl" class="img"><img :src="v.imgUrl" height="100" /></div>
                  </div>
                  <div class="d-c ml10">
                    <div class="d-b-c">
                      <el-button type="primary" plain icon="el-icon-upload" @click="openUpload('banner', i)">上传图片</el-button>
                      <el-input v-model="v.linkUrl" class="max-w460" style="width:200px"></el-input>
                      <el-button type="primary" @click="changeLink('banner', i)">选择链接</el-button>
                      <el-button @click="delBanner(i)">删除</el-button>
                    </div>
                    <p class="gray9">图片尺寸：345x144px 或 高清690x288px（比例一样就可以，尺寸按实际情况）</p>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
        <!-- <p class="gray9">奖励金分配比例</p> -->
      </el-form-item>

      <div class="common-form">搜索</div>
      <el-form-item label="热门关键词">
        <el-input v-model="form.search.hot_word" type="textarea" rows="5" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">打卡</div>
      <el-form-item label="打卡分享图">
        <div class="img-item">
            <div class="addimg-select" @click="openUpload('daka_share_img')" v-if="!form.daka_share_img"><i class="el-icon-plus"></i></div>
            <el-image class="imgw100" v-else :src="form.daka_share_img" fit="cover" alt="" :preview-src-list="[form.daka_share_img]" />
            <a v-if="form.daka_share_img" href="javascript:void(0);" class="delete-btn" @click.stop="form.daka_share_img=''"><i class="el-icon-close"></i></a>
        </div>
        <p class="gray9">尺寸：690x1373px</p>
      </el-form-item>

      <el-form-item label="打卡分享图文字">
        <el-input v-model="form.daka_content" class="max-w460" type="textarea" :rows="5" style="width:400px"></el-input>
      </el-form-item>

      <div class="common-form">拟排名</div>
      <el-form-item label="满足N人填写才显示排名">
        <el-input v-model="form.virtual_ranking_display_count" class="max-w460" style="width:200px">
          <template slot="append">人</template>
        </el-input>
      </el-form-item>
      <el-form-item label="头部图片">
        <div class="img-item">
            <div class="addimg-select" @click="openUpload('virtual_ranking_top_img')" v-if="!form.virtual_ranking_top_img"><i class="el-icon-plus"></i></div>
            <el-image class="imgw100" v-else :src="form.virtual_ranking_top_img" fit="cover" alt="" :preview-src-list="[form.virtual_ranking_top_img]" />
            <a v-if="form.virtual_ranking_top_img" href="javascript:void(0);" class="delete-btn" @click.stop="form.virtual_ranking_top_img=''"><i class="el-icon-close"></i></a>
        </div>
        <p class="gray9">尺寸：宽度750px，高度自适应</p>
      </el-form-item>

      <el-form-item label="拟排名说明">
        <el-input v-model="form.virtual_ranking_intro" class="max-w460" type="textarea" :rows="5" style="width:400px"></el-input>
      </el-form-item>

      <el-form-item label="二维码">
        <div class="img-item">
            <div class="addimg-select" @click="openUpload('virtual_ranking_qrcode')" v-if="!form.virtual_ranking_qrcode"><i class="el-icon-plus"></i></div>
            <el-image class="imgw100" v-else :src="form.virtual_ranking_qrcode" fit="cover" alt="" :preview-src-list="[form.virtual_ranking_qrcode]" />
            <a v-if="form.virtual_ranking_qrcode" href="javascript:void(0);" class="delete-btn" @click.stop="form.virtual_ranking_qrcode=''"><i class="el-icon-close"></i></a>
        </div>
        <p class="gray9">尺寸：宽度210px，高度自适应</p>
      </el-form-item>

      <div class="common-form">激活码</div>
      <el-form-item label="功用激活详情">
        <div class="img-item">
            <div class="addimg-select" @click="openUpload('code_info')" v-if="!form.code_info"><i class="el-icon-plus"></i></div>
            <el-image class="imgw100" v-else :src="form.code_info" fit="cover" alt="" :preview-src-list="[form.code_info]" />
            <a v-if="form.code_info" href="javascript:void(0);" class="delete-btn" @click.stop="form.code_info=''"><i class="el-icon-close"></i></a>
        </div>
        <p class="gray9">尺寸：宽度750px，高度自适应</p>
      </el-form-item>

      <el-form-item label="专属老师">
        <div class="img-item">
            <div class="addimg-select" @click="openUpload('teacher_info')" v-if="!form.teacher_info"><i class="el-icon-plus"></i></div>
            <el-image class="imgw100" v-else :src="form.teacher_info" fit="cover" alt="" :preview-src-list="[form.teacher_info]" />
            <a v-if="form.teacher_info" href="javascript:void(0);" class="delete-btn" @click.stop="form.teacher_info=''"><i class="el-icon-close"></i></a>
        </div>
        <p class="gray9">尺寸：宽度750px，高度自适应</p>
      </el-form-item>

      <el-form-item label="积分审核老师">
        <div class="img-item">
            <div class="addimg-select" @click="openUpload('point_teacher_qrcode')" v-if="!form.point_teacher_qrcode"><i class="el-icon-plus"></i></div>
            <el-image class="imgw100" v-else :src="form.point_teacher_qrcode" fit="cover" alt="" :preview-src-list="[form.point_teacher_qrcode]" />
            <a v-if="form.point_teacher_qrcode" href="javascript:void(0);" class="delete-btn" @click.stop="form.point_teacher_qrcode=''"><i class="el-icon-close"></i></a>
        </div>
        <p class="gray9">积分任务完成后请联系审核老师</p>
      </el-form-item>

      <div class="common-form">考研择校</div>
      <el-form-item label="顶部广告图">
        <div class="d-s-c">
          <div class="img-item" style="width: 200px;">
            <div class="addimg-select" @click="openUpload('school_banner')" v-if="!form.school_banner"><i class="el-icon-plus"></i></div>
            <el-image height="100" v-else :src="form.school_banner" fit="contain" alt="" :preview-src-list="[form.school_banner]" />
            <a v-if="form.school_banner" href="javascript:void(0);" class="delete-btn" @click.stop="form.school_banner=''"><i class="el-icon-close"></i></a>
          </div>
          <div class="ml20">
            <el-input v-model="form.school_banner_url" class="max-w460" style="width:400px">
              <el-button type="primary" slot="append" @click="changeLink('school_banner_url')">选择链接</el-button>
            </el-input>
            <p class="gray9">图片尺寸：345x144px 或 高清690x288px（比例一样就可以，尺寸按实际情况）</p>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="免费咨询底图">
        <div class="d-s-c">
          <div class="img-item">
            <div class="addimg-select" @click="openUpload('school_free_consult')" v-if="!form.school_free_consult"><i class="el-icon-plus"></i></div>
            <el-image class="imgw100" v-else :src="form.school_free_consult" fit="cover" alt="" :preview-src-list="[form.school_free_consult]" />
            <a v-if="form.school_free_consult" href="javascript:void(0);" class="delete-btn" @click.stop="form.school_free_consult=''"><i class="el-icon-close"></i></a>
          </div>
          <div class="ml20">
            <el-input v-model="form.school_free_consult_url" class="max-w460" style="width:400px">
              <el-button type="primary" slot="append" @click="changeLink('school_free_consult_url')">选择链接</el-button>
            </el-input>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="免费咨询文字">
        <el-input v-model="form.school_free_consult_text" class="max-w460" style="width:400px"></el-input>
      </el-form-item>

      <br>
      <br>
      <br>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </div>
    </el-form>

    <!--上传图片组件-->
    <Upload v-if="is_upload" :isupload="is_upload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink
    >
  </div>
</template>

<script>
  import SettingApi from '@/api/study/setting.js';
  import Upload from '@/components/file/Upload';
  import Setlink from "@/components/setlink/Setlink";
  import draggable from 'vuedraggable';
  export default {
    components: {
      Upload,
      Setlink,
      draggable
    },
    data() {
      return {
        /*form表单数据*/
        form: {},
         /*是否正在加载*/
        loading: false,
        /*是否上传图片*/
        is_upload: false,
        type: '',
        is_linkset: false,
        index: 0,
      };
    },
    props:{
      settingData:Object
    },
    created() {
      this.form=this.settingData.data.index.values;
    },

    methods: {
      /*提交表单*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = self.form;
        SettingApi.home(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*上传*/
      openUpload(name, index) {
        this.type = name;
        this.index = index ? index : 0;
        this.is_upload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null) {
          if (this.type == 'banner') {
            this.form[this.type][this.index].imgUrl = e[0].file_path;
          }else {
            this.form[this.type] = e[this.index].file_path;
          }
          
        }
        this.is_upload = false;
      },

      /*选择链接*/
      changeLink(name, index) {
        this.type = name;
        this.index = index;
        this.is_linkset = true;
      },

      /*获取链接并关闭弹窗*/
      closeLinkset(e) {
        this.is_linkset = false;
        if (e) {
          if (this.type == 'notice'){
            this.form[this.type].linkUrl = e.url;
          }else if (this.type == 'banner'){
            this.form[this.type][this.index].linkUrl = e.url;
          }else if (this.type == 'school_banner_url' || this.type == 'school_free_consult_url'){
            this.form[this.type] = e.url;
          }
          // this.curItem.data[this.index].name = "链接到" + " " + e.type + " " + e.name;
        }
      },

      addBanner(){
        this.form.banner.push({imgUrl: '', linkUrl: ''})
      },
      delBanner(i){
        this.form.banner.splice(i, 1);
      }

    }

  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/study/setting/part/Index.vue